<div class="progress-bar-grid">
  @for (item of data; track item) {
    <zipari-progress-bar [data]="item"> </zipari-progress-bar>
  }
</div>
